import { createFileRoute } from '@tanstack/react-router';
import { campaignExperimentRedirect, CampaignExperimentLegacyRoute } from './-campaign-experiment-redirects';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests',
)({
  component: CampaignExperimentLegacyRoute,
  beforeLoad: campaignExperimentRedirect(),
});
